import { CustomerStatus } from 'components/customer/customer.constants';
import {
  AccountChangeLogActionType,
  AccountChangeLogType,
  Customer,
} from '../user-domain.types';

export const getCustomersData = {
  resultsPaging: {
    total: 15482,
    count: 10,
    totalPages: 1,
    currentPage: 1,
  },
  users: [
    {
      userId: '41af7734-3499-4e23-9679-5abfaf368498',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      email: 'abc123@gmail.com',
      gender: null,
      dateOfBirth: null,
      phoneNumber: '1313232323',
      firstName: null,
      lastName: null,
      baseLanguagePrefrerence: 'EN',
      blocked: false,
      aliasId: 'abc11',
      extendedAttributes: {
        LOYALTY_POINT: ['330143'],
        USER_ACCOUNT_NUMBER: ['PLD000006288'],
        NO_OF_TRANSACTIONS: ['0'],
      },
    },
    {
      userId: '40d81a8f-c844-4315-8373-8697d546b5d4',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      email: 'ishalinibalan+001@gmail.com',
      gender: null,
      dateOfBirth: null,
      phoneNumber: '6726416070',
      firstName: null,
      lastName: null,
      baseLanguagePrefrerence: 'EN',
      blocked: false,
      aliasId: 'ishalinib6070',
      extendedAttributes: {
        LOYALTY_POINT: ['20'],
        SMS_MARKETING_OPT_IN: ['TRUE'],
        USER_AFFILIATION: ['CUSTOMER'],
        USER_ACCOUNT_NUMBER: ['PLD016411'],
        SMS_TXN_OPT_IN: ['TRUE'],
        AUTHENTICATION_PROVIDERS: ['INCENTIVIO'],
        NO_OF_TRANSACTIONS: ['0'],
        EMAIL_OPT_IN: ['TRUE'],
      },
    },
    {
      userId: '1dbae494-b53a-4faf-8594-c66c909a3161',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      email: 'shihans@gmail.com',
      gender: null,
      dateOfBirth: null,
      phoneNumber: '6434646646',
      firstName: null,
      lastName: null,
      baseLanguagePrefrerence: 'EN',
      blocked: false,
      aliasId: 'shih3',
      extendedAttributes: {
        AVERAGE_PURCHASES_PER_WEEK: ['0.44'],
        QUANTILE_PURCHASES_PER_MONTH: ['85'],
        DAYS_SINCE_LAST_PURCHASE: ['63'],
        NO_OF_TRANSACTIONS: ['4'],
        PURCHASES_PER_MONTH: ['1.9'],
        QUANTILE_DAYS_SINCE_LAST_PURCHASE: ['80'],
        QUANTILE_AVERAGE_BASKET_VALUE: ['70'],
        EMAIL_OPT_IN: ['FALSE'],
        LOYALTY_POINT: ['329732'],
        USER_ACCOUNT_NUMBER: ['PLD000000076'],
        AVERAGE_BASKET_VALUE_PER_MONTH: ['48.56'],
        BASKET_VALUE_TOTAL: ['101.97'],
        AVERAGE_BASKET_VALUE: ['25.49'],
        LAST_PURCHAS_ON: ['2022-06-16'],
      },
    },
    {
      userId: '10793baa-93bd-41f0-b8db-a6d9fd017e4f',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      email: 'blocked@gmail.com',
      gender: null,
      dateOfBirth: null,
      phoneNumber: '8181811810',
      firstName: 'Blocked',
      lastName: 'User',
      baseLanguagePrefrerence: 'EN',
      blocked: true,
      aliasId: 'raji33',
      extendedAttributes: {
        LOYALTY_POINT: ['530'],
        BIRTH_MONTH: ['DECEMBER'],
        SMS_MARKETING_OPT_IN: ['FALSE'],
        USER_AFFILIATION: ['CUSTOMER'],
        USER_ACCOUNT_NUMBER: ['PLD000011029'],
        SMS_TXN_OPT_IN: ['TRUE'],
        NO_OF_TRANSACTIONS: ['0'],
      },
    },
    {
      userId: '20450d06-0174-4774-ab47-6592d26a58b5',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      email: 'reopened@incentivio.com',
      gender: null,
      dateOfBirth: null,
      phoneNumber: '2323232323',
      firstName: null,
      lastName: null,
      baseLanguagePrefrerence: 'EN',
      blocked: false,
      reopened: true,
      linked: false,
      aliasId: 'an.u1',
      extendedAttributes: {
        LOYALTY_POINT: ['547'],
        USER_ACCOUNT_NUMBER: ['PLD000004624'],
        NO_OF_TRANSACTIONS: ['0'],
      },
    },
    {
      userId: '33b954be-bbc7-49fc-b197-7bdafe5eb859',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      email: 'linkedAccount@incentivio.com',
      gender: null,
      dateOfBirth: null,
      phoneNumber: '0777775218',
      firstName: 'Linked',
      lastName: 'Account',
      baseLanguagePrefrerence: 'EN',
      blocked: false,
      reopened: true,
      linked: true,
      aliasId: 'test1983',
      extendedAttributes: {
        LOYALTY_POINT: ['330087'],
        USER_ACCOUNT_NUMBER: ['PLD000001659'],
        NO_OF_TRANSACTIONS: ['0'],
      },
    },
    {
      userId: '35726c56-fc5f-4609-a671-7b0a20cf6cab',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      email: 'rajithaaeturnum+42@gmail.com',
      gender: null,
      dateOfBirth: null,
      phoneNumber: '8484848481',
      firstName: null,
      lastName: null,
      baseLanguagePrefrerence: 'EN',
      blocked: false,
      aliasId: 'raji17',
      extendedAttributes: {
        LOYALTY_POINT: ['546'],
        USER_ACCOUNT_NUMBER: ['PLD000004897'],
        NO_OF_TRANSACTIONS: ['0'],
      },
    },
    {
      userId: '345bdb70-8eec-4837-8615-ac49ef661b09',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      email: 'aetqatest+0936@gmail.com',
      gender: null,
      dateOfBirth: null,
      phoneNumber: '8484886464',
      firstName: null,
      lastName: null,
      baseLanguagePrefrerence: 'EN',
      blocked: false,
      aliasId: 'aetqatest5726',
      extendedAttributes: {
        LOYALTY_POINT: ['543'],
        SMS_MARKETING_OPT_IN: ['TRUE'],
        USER_AFFILIATION: ['CUSTOMER'],
        USER_ACCOUNT_NUMBER: ['PLD000014593'],
        SMS_TXN_OPT_IN: ['TRUE'],
        NO_OF_TRANSACTIONS: ['0'],
        EMAIL_OPT_IN: ['TRUE'],
        EXT_LOYALTY_ID: ['STLO1100000001000271'],
      },
    },
    {
      userId: '02fcf6f5-7407-4127-b7ac-bb675ec8166f',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      email: 'aetqatest41992+5011@gmail.com',
      gender: null,
      dateOfBirth: null,
      phoneNumber: '9635588855',
      firstName: null,
      lastName: null,
      baseLanguagePrefrerence: 'EN',
      blocked: false,
      aliasId: 'aetqatest9431',
      extendedAttributes: {
        LOYALTY_POINT: ['535'],
        SMS_MARKETING_OPT_IN: ['TRUE'],
        USER_AFFILIATION: ['CUSTOMER'],
        USER_ACCOUNT_NUMBER: ['PLD000014560'],
        SMS_TXN_OPT_IN: ['TRUE'],
        NO_OF_TRANSACTIONS: ['0'],
        EMAIL_OPT_IN: ['TRUE'],
        EXT_LOYALTY_ID: ['STLO1100000001000238'],
      },
    },
    {
      userId: '41be4646-4cca-48dd-a203-afbe51400a81',
      clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      email: 'aetqatest4+4075@gmail.com',
      gender: null,
      dateOfBirth: null,
      phoneNumber: '6855555558',
      firstName: null,
      lastName: null,
      baseLanguagePrefrerence: 'EN',
      blocked: false,
      aliasId: 'aetq639',
      extendedAttributes: {
        LOYALTY_POINT: ['545'],
        SMS_MARKETING_OPT_IN: ['TRUE'],
        USER_AFFILIATION: ['CUSTOMER'],
        USER_ACCOUNT_NUMBER: ['PLD000005792'],
        SMS_TXN_OPT_IN: ['TRUE'],
        NO_OF_TRANSACTIONS: ['0'],
        EMAIL_OPT_IN: ['TRUE'],
      },
    },
  ],
};

export const getCustomerData: Customer = {
  userId: '02e4d2f5-2f4e-44cd-833f-d4c7e2e408ab',
  mergedPrimaryUserAccountId: null,
  household: null,
  address: null,
  clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  firstName: 'Test',
  lastName: 'User',
  email: 'aetqatest20+0804@gmail.com',
  phoneNumber: '8787878878',
  externalId: '25343',
  baseLanguagePrefrerence: 'EN',
  blocked: false,
  reopened: false,
  linked: false,
  status: CustomerStatus.VERIFIED,
  howAcquired: 'THROUGH_AN_IPHONE',
  gender: null,
  dateOfBirth: '1993-05-12',
  accountAliasId: 'aetqatest6754',
  extendedAttributes: {
    ABCD: '1',
    '1998_TAG': 'TRUE',
    '25012023AUTOMESSAGE': 'TRUE',
    ANTHONY_TAG: '12',
    LOYALTY_POINT: '535',
    AVERAGE_BASKET_VALUE: '14.6923432234',
    BASKET_VALUE_TOTAL: '14.6923423432',
    DAYS_SINCE_LAST_PURCHASE: '12',
    PURCHASES_PER_MONTH: '10',
    NO_OF_TRANSACTIONS: '1',
    SMS_MARKETING_OPT_IN: 'TRUE',
    USER_AFFILIATION: 'CUSTOMER',
    USER_ACCOUNT_NUMBER: 'PLD000014361',
    SMS_TXN_OPT_IN: 'TRUE',
    AUTHENTICATION_PROVIDERS: 'INCENTIVIO',
    EMAIL_OPT_IN: 'TRUE',
    SEG_GREGULAR_TEST_LOYALTY_TIER: 'TRUE',
  },
  emailBounced: false,
  createdDate: '2022-09-26T06:35:59.000+00:00',
  userProfileImageUrl:
    'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/profile/5c77dc94-a2e3-4929-a237-e1f6fd612724.png',
};

export const getCustomerDataWithoutImage: Customer = {
  ...getCustomerData,
  userProfileImageUrl: null,
};

export const getResetPasswordLink =
  'https://order.incentiviodev.com/c/palmlanedev/auth/resetpassword?id=a47b926e-889c-45fd-8beb-737bc5c08a0al';

export const getAccountChangeLogs: AccountChangeLogType[] = [
  {
    adminUserName: 'Test Admin 0',
    description: 'Test block by 0',
    actionType: AccountChangeLogActionType.BLOCKED,
    changedDateTime: '2025-08-21T05:11:17Z',
  },
  {
    adminUserName: 'Test Admin 0',
    description: 'Test unblock by 0',
    actionType: AccountChangeLogActionType.UNBLOCKED,
    changedDateTime: '2025-08-22T05:11:17Z',
  },
  {
    adminUserName: 'Test Admin 1',
    description: 'Test link by 1',
    actionType: AccountChangeLogActionType.LINKED,
    changedDateTime: '2025-08-23T05:11:17Z',
  },
  {
    adminUserName: 'Test Admin 1',
    description: 'Test unlink by D',
    actionType: AccountChangeLogActionType.UNLINKED,
    changedDateTime: '2025-08-24T05:11:17Z',
  },
  {
    adminUserName: 'Test Admin 1',
    description: 'Test block by D',
    actionType: AccountChangeLogActionType.REOPEN,
    changedDateTime: '2025-08-25T05:11:17Z',
  },
  {
    adminUserName: 'Test Admin 1',
    description: 'Test delete by 1',
    actionType: AccountChangeLogActionType.DELETED,
    changedDateTime: '2025-08-26T05:11:17Z',
  },
  {
    adminUserName: 'Test Admin 1',
    description: 'Test update by 1',
    actionType: AccountChangeLogActionType.UPDATED,
    changedDateTime: '2025-08-27T05:11:17Z',
  },
  {
    adminUserName: 'SYSTEM',
    description: 'Automated Block due to Hitting Daily Order Count Threshold',
    actionType: AccountChangeLogActionType.AUTO_BLOCKED,
    changedDateTime: '2025-08-28T05:11:17Z',
  },
  {
    adminUserName: 'SYSTEM',
    description: 'Automated Block due to Hitting Saved Card Count Threshold',
    actionType: AccountChangeLogActionType.AUTO_BLOCKED,
    changedDateTime: '2025-08-29T05:11:17Z',
  },
  {
    adminUserName: '',
    description: 'Automated Flag due to Hitting Saved Card Count Threshold',
    actionType: AccountChangeLogActionType.AUTO_FLAGGED,
    changedDateTime: '2026-10-01T04:05:24Z',
  },
];
